module.exports = __webpack_public_path__ + "static/ficha_projeto_70630-4fe87e2124874e58760d195a3539890d.pdf";